<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchSubpoenas({ status = '', page }) {
    const params = { status, page };
    return axios.get('requerimentos/intimacoes', { params, ...AS.getDefaultHeaders() });
  },
  adminFetchSubpoenas({ status = '', page }) {
    const params = { status, page };
    return axios.get('admin/requerimentos/intimacoes', { params, ...AS.getDefaultHeaders() });
  },
};

</script>